import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const LegalNameField = () => {
  return (
    <FormField label="Legal Name" htmlFor="legalName">
      <FormikInput id="legalName" name="legalName" />
    </FormField>
  );
};

export default LegalNameField;
